<!-- déclencheur porté par la barre d'outils : ce composant ne gère plus que la modale -->
<cam-layout-full-panel
  [toggleState]="this.conversationAttachmentsModal.open()"
  (closeEvent)="this.conversationAttachmentsModal.open.set(false)"
  title="communication.documents.modal.title.attachments"
  type="modal"
  size="lg"
>
  @if (this.conversationAttachmentsModal.open()) {
    <cam-documents-attachments-modal-content
      [modalState]="this.conversationAttachmentsModal"
      [sectionsHelper]="this.sectionsHelper()"
      (closeEvent)="this.onConfirmed($event)"
    ></cam-documents-attachments-modal-content>
  }
</cam-layout-full-panel>
